// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { store } from './store.js'

// Firebase & VueFire
const fb = require('./firebaseConfig.js')
import { rtdbPlugin, firestorePlugin } from 'vuefire'

// Prismic & SEO
import VueMeta from 'vue-meta'
import VueResource from 'vue-resource'
import PrismicVue from 'prismic-vue'
import linkResolver from './link-resolver'

// Date & Time
import VueMoment from 'vue-moment'

// Other UI
import * as VueGoogleMaps from 'vue2-google-maps'
import Notifications from 'vue-notification'
import VueNativeNotification from 'vue-native-notification'
import VuePlyr from 'vue-plyr/dist/vue-plyr.esm'
import 'vue-plyr/dist/vue-plyr.css'
import VueScrollTo from 'vue-scrollto'
import VueLazyLoad from 'vue-lazyload'
import 'vue-image-lightbox/dist/vue-image-lightbox.min.css'
import VueGeolocation from 'vue-browser-geolocation'

// import Pace from 'pace-progress'

import './assets/scss/app.scss'
const prismicAccessToken = 'MC5YdVBVeHhBQUFDTUFaR1FG.77-9P--_vUPvv73vv70q77-977-977-977-977-977-9cO-_ve-_ve-_vT_vv70tVu-_vTjvv73vv73vv73vv70O77-977-9XVg'


/**
 * Vue Config
 */

Vue.config.productionTip = false
Vue.config.ignoredElements = [/^ion-/]

Vue.use(firestorePlugin)
Vue.use(rtdbPlugin)

Vue.use(VueResource)
Vue.use(PrismicVue, {
	endpoint: window.prismic.endpoint,
	linkResolver,
	apiOptions: { prismicAccessToken }
})
Vue.use(VueMoment)
Vue.use(VueGoogleMaps, {
	load: {
		key: 'AIzaSyCF4-NeDe2ZBLl7XO--sRY3yQshCymHWBU', // AIzaSyDxozjSICj1ztFxGjNfxVycqUSb5WMOJog
		libraries: 'places'
	},
	installComponents: true
})
Vue.use(VueMeta)
Vue.use(Notifications)
Vue.use(VueNativeNotification, {
	// Automatic permission request before
	// showing notification (default: true)
	requestOnNotify: true
})
Vue.use(VuePlyr, {
	plyr: {}
})
Vue.use(VueScrollTo)
Vue.use(VueLazyLoad)
Vue.use(VueGeolocation)

// Custom Prototypes
Vue.prototype.$firebase = fb.firebase

// Handle page reloads
// Pace.start()

Vue.directive('click-outside', {
	bind: (el, binding, vnode) => {
		el.clickOutsideEvent = (event) => {
			if(!(el === event.target || el.contains(event.target))){
				vnode.context[binding.expression](event)
			}
		}
		document.body.addEventListener('click', el.clickOutsideEvent)
	},
	unbind(){
		if(typeof el !== 'undefined'){
			document.body.removeEventListener('click', el.clickOutsideEvent)
		}
	}
})

let app
fb.auth.onAuthStateChanged(async(user) => {

	// Settings
	store.dispatch('bindSettings')

	// All Users
	store.dispatch('bindOnlineStatus')
	store.dispatch('bindAllUsers')
	await store.dispatch('fetchAllUsers')
	store.dispatch('bindChats')
	
	// Current user & Profile
	if(user){
		store.commit('setCurrentUser', user)
		await store.dispatch('fetchUserProfile', user)
		store.dispatch('bindUserProfileFriends', user)
		store.dispatch('fetchDefaultLocation')
	}

	// Render App
	if(!app){
		app = new Vue({
			el: '#app',
			router,
			store,
			render: h => h(App),
			mounted() {
				// Pace.on('hide', () => {
					document.dispatchEvent(new Event('app.rendered'))
				// })
			}
		}).$mount()
	}
})


// WEBPACK FOOTER //
// ./src/main.js